<div class=" pad">
    <div class="calsoft-vertical-navigation-content"
    calsoftScrollbar
    [calsoftScrollbarOptions]="{ suppressScrollX: true}"
    #navigationContent>
    <calsoft-layout [pageNated]="true" [value]="2"></calsoft-layout>
    </div>
</div>